import * as React from 'react'
import { SearchForm } from '../MediaUploadPrompt/SearchForm'
import { BrowserRouter as Router } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { GithubIssue } from 'common/Prose/nodeViews/GithubEmbed/GithubIssue'
import { GithubPull } from 'common/Prose/nodeViews/GithubEmbed/GithubPull'

import Styles from '../Prompt.module.scss'
import { GenericEmbed, SetState } from 'types'
import { GITHUB_INTEGRATION_REGEX } from 'screens/ProseEdit/utils'

export const GithubPreview = ({
  inputRef,
  inputValue,
  setInputValue,
  regexResult,
  setStagedEmbed,
  onSuccess,
}: {
  inputRef: React.RefObject<HTMLInputElement>
  inputValue: string
  setInputValue: React.Dispatch<React.SetStateAction<string>>
  regexResult: RegExpExecArray | null
  setStagedEmbed: SetState<GenericEmbed | undefined>
  onSuccess: () => void
}) => {
  const queryClient = new QueryClient()
  let type = regexResult?.groups?.resourceName
  if (type === 'issues') type = 'issue'

  const validUrl = (value: string) => {
    const regexResult = GITHUB_INTEGRATION_REGEX.exec(value)

    return !!regexResult
  }

  return (
    <div>
      <SearchForm
        inputRef={inputRef}
        placeholder="https://github.com/my-organization/my-repository/issues/123"
        query={inputValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setInputValue(e.target.value)

          if (!validUrl(e.target.value)) {
            setStagedEmbed(undefined)
          }
        }}
        onSubmit={(e) => {
          e?.preventDefault()

          if (validUrl(inputValue)) {
            onSuccess()
          }
        }}
        clearQuery={() => {
          setInputValue('')
          setStagedEmbed(undefined)
        }}
      />
      <div className={Styles.previewContainer}>
        {regexResult && regexResult.groups?.resourceName ? (
          <Router>
            <QueryClientProvider client={queryClient}>
              {type === 'issue' && (
                <GithubIssue preview node={{ attrs: { type: 'issue', link: inputValue, mode: 'card' } } as any} />
              )}
              {type === 'pull' && (
                <GithubPull preview node={{ attrs: { type: 'pull', link: inputValue, mode: 'card' } } as any} />
              )}
            </QueryClientProvider>
          </Router>
        ) : (
          <div className={Styles.invalid}>
            {/^(https?:\/\/)github\.com/.test(inputValue) ? (
              <>
                Hm, that didn't work.
                <br />
                Try inserting an individual pull request or issue, then try again.
              </>
            ) : (
              'Check your embed link and try again.'
            )}
          </div>
        )}
      </div>
    </div>
  );
}
